import React from "react";
import { Link } from "react-router-dom";
import { FaSearch, FaChevronRight } from "react-icons/fa";
import { connect } from "react-redux";
import * as actions from "../redux/actions/marketstoreActions";
import { Translate, I18n } from "react-redux-i18n";

import "./styles/MarketStoreList.css";

function getInitial(name) {
  return (name || "")
    .replace(/\s+/, " ")
    .split(" ")
    .slice(0, 2)
    .map((v) => v && v[0].toUpperCase())
    .join("");
}

function filterStores(list, query) {
  const q = query.trim().toUpperCase();
  if (!q) return list;
  return list.filter((item) => {
    const name = (item.Name || "").toUpperCase();
    const description = (item.Description || "").toUpperCase();
    const home = (item.Home || "").toUpperCase();
    return name.includes(q) || description.includes(q) || home.includes(q);
  });
}

class MarketStoreItem extends React.Component {
  render() {
    const { item } = this.props;

    return (
      <li className="marketstore-list__item">
        <Link
          to={`/marketstore/show/${item.Id}`}
          className="marketstore-list__link"
          onClick={this.props.onClick}
        >
          <div className="marketstore-list__avatar-wrap">
            {item.Logo ? (
              <img
                src={item.Logo}
                className="marketstore-list__avatar"
                alt={item.Name}
              />
            ) : (
              <span className="marketstore-list__avatar marketstore-list__avatar--initials">
                {getInitial(item.Name)}
              </span>
            )}
          </div>

          <div className="marketstore-list__body">
            <span className="marketstore-list__name">{item.Name}</span>
            {item.Description && (
              <span className="marketstore-list__description">
                {item.Description}
              </span>
            )}
            {item.Home && (
              <span className="marketstore-list__home">{item.Home}</span>
            )}
          </div>

          <FaChevronRight className="marketstore-list__chevron" />
        </Link>
      </li>
    );
  }
}

class MarketStoreList extends React.Component {
  state = {
    text_search: "",
  };

  onChange = (event) => {
    this.setState({ text_search: event.target.value });
  };

  onClick = (store) => {
    this.props.SetSelectedStore(store, this.props.user_id, this.props.token);
  };

  render() {
    const { marketstoreList } = this.props;
    const filteredList = filterStores(marketstoreList, this.state.text_search);

    if (marketstoreList.length === 0) {
      return (
        <div className="marketstore-list__empty">
          <Translate value="marketstore_not_list" />
        </div>
      );
    }

    return (
      <React.Fragment>
        <div className="marketstore-list__search">
          <FaSearch className="marketstore-list__search-icon" />
          <input
            type="text"
            placeholder={I18n.t("search")}
            onChange={this.onChange}
            className="marketstore-list__search-input"
            value={this.state.text_search}
          />
        </div>

        {filteredList.length === 0 ? (
          <div className="marketstore-list__empty">
            <Translate value="not_found" />
          </div>
        ) : (
          <ul className="marketstore-list">
            {filteredList.map((item) => (
              <MarketStoreItem
                item={item}
                key={item.Id}
                onClick={() => {
                  this.onClick(item);
                }}
              />
            ))}
          </ul>
        )}
      </React.Fragment>
    );
  }
}

function mapStateToProps(reducers) {
  return {
    user_id: reducers.session.auth.id,
    token: reducers.session.auth.access_token,
    marketstoreList: reducers.marketstoreList.list || [],
  };
}

const mapDispatchToProps = (dispatch) => ({
  SetSelectedStore: (item, user_id, token) =>
    dispatch(actions.setStore({ item, user_id, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(MarketStoreList);
